import { useCurrentAccountContext } from '@retailer-platform/dashboard/utils'
import { useAccessControl, ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { FeatureToggle } from '../../../../access-control/featureToggles'

export const useIsInAppEnabled = () => {
  const currentAccountContext = useCurrentAccountContext()
  const accessControl = useAccessControl()

  const isInAppEnabled =
    !!currentAccountContext?.account?.featureToggles?.find(
      feature => feature.name === FeatureToggle.notificationSettings
    ) && accessControl({ minICPlatformVersion: ICPlatformVersion.r2025_07_0 })

  return isInAppEnabled
}
